import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { hideSidebarAction } from "redux-store/ui-state/sidebar";
import { CloseSidebar } from "ui/sidebar";

function mapDispatchToProps(dispatch) {
  return {
    hideSidebar: () => {
      dispatch(hideSidebarAction);
    },
  };
}

const ConnectedCloseSidebar = connect(null, mapDispatchToProps)(CloseSidebar);

const RouteCloseSidebar = withRouter(ConnectedCloseSidebar);

export { ConnectedCloseSidebar, RouteCloseSidebar };
